// extracted by mini-css-extract-plugin
export default {"-large":"jspokPKMWv6dGMnx9A51","aiUploadingTextColor":"EVVfBDaPljteXjVajt0g","text":"THRQQWihHqcHzJKqZoOD"};